import Text from '@/components/ui/custom/dataDisplay/Text';
import { TrophyGold, TrophySilver, TrophyBronze } from '@/components/icons';
import { ClassNameComponent } from '@/utils/ClassNameComponent';
import { twMerge } from 'tailwind-merge';

type TrophyWithPositionProps = {
  position: number;
  className?: Pick<ClassNameComponent, 'text' | 'icon' | 'base'>;
};

export const TrophyWithPosition = ({
  position,
  className,
}: TrophyWithPositionProps) => {
  const TrophyIcons = [TrophyGold, TrophySilver, TrophyBronze];

  const TrophyIcon = TrophyIcons[position - 1];
  return (
    <div
      className={twMerge(
        'relative flex flex-col items-center justify-start gap-1',
        className?.base,
      )}
    >
      <TrophyIcon className={className?.icon} />
      <Text
        text={position + 'º'}
        className={twMerge('absolute top-1 text-base-100', className?.text)}
      />
    </div>
  );
};

export default TrophyWithPosition;
